// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__8mZ5k","container":"styles_container__Ise7M","title":"styles_title__3neYI","wrapper":"styles_wrapper__1jEYR","answer":"styles_answer__3jgLY"};